const FormSkeleton = () => {
    return (
      <div className="p-6 bg-white rounded-lg shadow-sm animate-pulse">
        {/* Topic field */}
        <div className="mb-4">
          <div className="h-4 w-16 bg-gray-200 rounded mb-2"></div>
          <div className="h-10 bg-gray-200 rounded w-full"></div>
        </div>
  
        {/* Min and Max Length */}
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <div className="h-4 w-24 bg-gray-200 rounded mb-2"></div>
            <div className="h-10 bg-gray-200 rounded w-full"></div>
          </div>
          <div>
            <div className="h-4 w-24 bg-gray-200 rounded mb-2"></div>
            <div className="h-10 bg-gray-200 rounded w-full"></div>
          </div>
        </div>
  
        {/* Language and Tone */}
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <div className="h-4 w-20 bg-gray-200 rounded mb-2"></div>
            <div className="h-10 bg-gray-200 rounded w-full"></div>
          </div>
          <div>
            <div className="h-4 w-20 bg-gray-200 rounded mb-2"></div>
            <div className="h-10 bg-gray-200 rounded w-full"></div>
          </div>
        </div>
  
        {/* Industry and Images */}
        <div className="grid grid-cols-2 gap-4 mb-6">
          <div>
            <div className="h-4 w-16 bg-gray-200 rounded mb-2"></div>
            <div className="h-10 bg-gray-200 rounded w-full"></div>
          </div>
          <div>
            <div className="h-4 w-24 bg-gray-200 rounded mb-2"></div>
            <div className="h-10 bg-gray-200 rounded w-full"></div>
          </div>
        </div>
  
        {/* Generate Button */}
        <div className="h-12 bg-gray-200 rounded w-full"></div>
      </div>
    );
  };
  
  export default FormSkeleton;